import type { Video, VideoCategory } from "../types/video";
import { videos } from "../mocks/videos";
import { categories } from "../mocks/categories";

export function getAllVideos(): Video[] {
  return videos;
}

export function getVideoById(id: string): Video | undefined {
  return videos.find((video) => video.id === id);
}

export function getVideosByCategory(category: VideoCategory): Video[] {
  return videos.filter((video) => video.category === category);
}

export function getFeaturedVideos(): Video[] {
  return [...videos].sort((a, b) => b.plays - a.plays).slice(0, 5);
}

export function getHotVideos(limit = 8): Video[] {
  return [...videos].sort((a, b) => b.plays - a.plays).slice(0, limit);
}

export function getRelatedVideos(video: Video, limit = 6): Video[] {
  return videos
    .filter((item) => item.category === video.category && item.id !== video.id)
    .sort((a, b) => b.plays - a.plays)
    .slice(0, limit);
}

export function searchVideos(keyword: string): Video[] {
  const key = keyword.trim().toLowerCase();
  if (!key) return [];
  return videos.filter((video) => {
    const inTitle = video.title.toLowerCase().includes(key);
    const inDesc = video.description.toLowerCase().includes(key);
    const inTags = video.tags.some((tag) => tag.toLowerCase().includes(key));
    const inAuthor = video.author.toLowerCase().includes(key);
    const categoryName = categories.find((c) => c.key === video.category)?.name ?? "";
    return inTitle || inDesc || inTags || inAuthor || categoryName.includes(key);
  });
}

export type SortKey = "latest" | "plays" | "comments";

export function sortVideos(list: Video[], sort: SortKey): Video[] {
  const cloned = [...list];
  if (sort === "plays") return cloned.sort((a, b) => b.plays - a.plays);
  if (sort === "comments") return cloned.sort((a, b) => b.comments - a.comments);
  return cloned.sort(
    (a, b) => new Date(b.uploadDate).getTime() - new Date(a.uploadDate).getTime(),
  );
}